export default __webpack_public_path__ + "static/media/namaste.b58ec67f.png";